import { RouteObject } from 'react-router';

import { ExportsCreateContainer } from './containers/ExportsCreateContainer';
import { ExportsContainer } from './containers/ExportsContainer';

const routes: RouteObject[] = [
    {
        path: 'exports',
        element: <ExportsContainer />,
        children: [
            {
                path: 'create',
                element: <ExportsCreateContainer />,
            },
        ],
    },
];

export default routes;
